import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TPropertyId } from 'stores/fieldAssetStore/helperTypes'
import type { TSelectedFieldAssetsStoreState } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { getArgsForAnchorCoordinates } from '../getArgsForAnchorCoordinates'

export type TSetByArg = { property: TPropertyId }

export const setBy = ({
  property: propertyArg,
}: TSetByArg): Partial<TSelectedFieldAssetsStoreState> | null => {
  const allProperties = fieldAssetStore.getState()?.properties
  const property = allProperties?.[propertyArg]

  if (!property || !property?.centroid?.coordinates) {
    return null
  }

  const { lng, lat } = property.centroid.coordinates
  const anchorCoordinates = { lng, lat }

  return getArgsForAnchorCoordinates({ anchorCoordinates, property })
}
